// A screen failed to render. The shell around it stays; the message says what happened and what to do, and
// shows no technical text (technical details belong in the Details drawer of later screens).

import { Button } from "react-aria-components";
import { Glyph } from "../../components/Glyph";
import { cx } from "../../lib/cx";
import { useT } from "../../lib/i18n";
import styles from "./shell.module.css";
import { usePageTitle } from "./usePageTitle";

export function ErrorState() {
  const t = useT();
  usePageTitle(t("error.title"));
  return (
    <div className={cx("sf-block", styles.notice, styles.readable)}>
      <div className="sf-banner sf-banner--error" role="alert">
        <Glyph name="blocker" />
        <div>
          <h1 className="sf-banner__title">{t("error.title")}</h1>
          <p>{t("error.text")}</p>
        </div>
        <div className="sf-banner__act">
          <Button
            className="sf-plate sf-plate--secondary"
            onPress={() => {
              window.location.reload();
            }}
          >
            {t("error.action")}
          </Button>
        </div>
      </div>
    </div>
  );
}
